import { useQuery } from '@apollo/react-hooks'

import { IPaginationInput } from '../../types/common'
import { IGetCorporationsByAdminData } from '../../types/businesses'
import { GET_CORPORATIONS_BY_ADMIN } from '../../queries/businesses'
import { useQueryParams } from '../../../utils'

export const CORPORATIONS_ROWS_PER_PAGE = [10, 20, 30]

export interface IBusinessCorporationsFilter {
  corporationName: string
  countryId: number | null
  citiesIds: number[]
  corporationTypesIds: number[]
}

export const useCorporations = (filter?: IBusinessCorporationsFilter) => {
  const [{ query }] = useQueryParams()
  const page = query.page ? parseInt(query.page) : 1
  const limit =
    query.limit && CORPORATIONS_ROWS_PER_PAGE.includes(parseInt(query.limit))
      ? parseInt(query.limit)
      : CORPORATIONS_ROWS_PER_PAGE[0]

  const { data, ...q } = useQuery<
    IGetCorporationsByAdminData,
    { pagination: IPaginationInput; filter?: IBusinessCorporationsFilter }
  >(GET_CORPORATIONS_BY_ADMIN, {
    variables: {
      pagination: { offset: (page - 1) * limit, limit },
      filter,
    },
    fetchPolicy: 'cache-first',
  })

  const corporations = data?.getCorporationsByAdmin.data ?? []
  const total = data?.getCorporationsByAdmin.total ?? 0

  return {
    corporations,
    total,
    page,
    limit,
    ...q,
  }
}
